import { Flex } from '~/design-system';

export default function CompaniesList({ children, ...rest }) {
  return (
    <Flex direction="column" {...rest}>
      {children}
    </Flex>
  );
}
